<template>
    <main id="games-wrapper">
        <div id="games-page" v-if="noCarousel">
            <div class="row">
                <div class="col-sm-12 col-md-12 py-2" v-for="(game, index) in games" :key="index">
                    <div class="card">
                        <img class="card-img-top img-game" :src="game.image" alt="Card image game">
                        <div class="card-body">
                            <div class="row justify-content-center">
                                <div class="col col-md-10">
                                    <a v-if="playgame" @click="playGameTracker(game)" target="_blank" :href="user.game_motogp_url" class="btn btn-mainkan btn-play py-2">{{ game.title_button }}</a>
                                    <a v-else :href="app_url+'/login'" class="btn btn-mainkan btn-play py-2">Login</a>
                                     <!-- <a class="btn btn-mainkan py-2">Coming Soon</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-12 col-md-6 py-2">
                    <div class="card">
                        <img class="card-img-top img-game" :src="base_url+'/images/game-2.png'" alt="Card image game">
                        <div class="card-body">
                            <div class="row justify-content-center">
                                <div class="col col-md-10">
                                    <a v-if="playgame" target="_blank" :href="user.game_racing_url" class="btn btn-mainkan btn-play py-2">Mainkan</a>
                                    <a v-else :href="app_url+'/login'" class="btn btn-mainkan btn-play py-2">Login</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div id="games-page" v-else>
            <div class="row" v-if="mobile">
                <carousel :per-page="1"  :mouse-drag="false" :navigationEnabled="true" :autoplay="true" :loop="true" navigationNextLabel='<i class="ion-chevron-right"></i>' navigationPrevLabel='<i class="ion-chevron-left"></i>'>
                    <slide>
                        <div class="col-sm-12 col-md-6 py-2" v-for="(game, index) in games" :key="index">
                            <div class="card">
                                <img class="card-img-top img-game" :src="game.image" alt="Card image game">
                                <div class="card-body">
                                    <div class="row justify-content-center">
                                        <div class="col col-md-10">
                                             <a v-if="playgame" @click="playGameTracker(game)" target="_blank" :href="user.game_motogp_url" class="btn btn-mainkan btn-play py-2">{{ game.title_button }}</a>
                                             <a v-else :href="app_url+'/login'" class="btn btn-mainkan btn-play py-2">Login</a>
                                              <!-- <a class="btn btn-mainkan py-2">Coming Soon</a> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slide>
                    <!-- <slide>
                        <div class="col-sm-12 col-md-6 py-2">
                            <div class="card">
                                <img class="card-img-top img-game" :src="base_url+'/images/game-2.png'" alt="Card image game">
                                <div class="card-body">
                                    <div class="row justify-content-center">
                                        <div class="col col-md-10">
                                            <a v-if="playgame" target="_blank" :href="user.game_racing_url" class="btn btn-mainkan btn-play py-2">Mainkan</a>
                                            <a v-else :href="app_url+'/login'" class="btn btn-mainkan btn-play py-2">Login</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slide> -->
                </carousel>
            </div>
            <div class="row" v-else>
                <div class="col-sm-12 col-md-6 py-2" v-for="(game, index) in games" :key="index">
                    <div class="card">
                        <img class="card-img-top img-game" :src="game.image" alt="Card image game">
                        <div class="card-body">
                            <div class="row justify-content-center">
                                <div class="col col-md-10">
                                    <a v-if="playgame" @click="playGameTracker(game)" target="_blank" :href="user.game_motogp_url" class="btn btn-mainkan btn-play py-2">{{ game.title_button }}</a>
                                    <a v-else :href="app_url+'/login'" class="btn btn-mainkan btn-play py-2">Login</a>
                                     <!-- <a class="btn btn-mainkan py-2">Coming Soon</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-12 col-md-6 py-2">
                    <div class="card">
                        <img class="card-img-top img-game" :src="base_url+'/images/game-2.png'" alt="Card image game">
                        <div class="card-body">
                            <div class="row justify-content-center">
                                <div class="col col-md-10">
                                            <a v-if="playgame" target="_blank" :href="user.game_racing_url" class="btn btn-mainkan btn-play py-2">Mainkan</a>
                                            <a v-else :href="app_url+'/login'" class="btn btn-mainkan btn-play py-2">Login</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </main>
</template>
<script>
import Axios from "axios";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from 'vue-carousel';

export default {
    props:['noCarousel'],
    components: {
			Carousel,
			Slide
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            user: {},
            loader:false,
            games : [],
            data:{
                hcid:'HCID00097601',
            },
            playgame:false,
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        const getUser = JSON.parse(localStorage.getItem('user'));
        var userStatus = getUser != null;
        if(userStatus == true){
            console.log('masuk');
            console.log(getUser);
            this.user = JSON.parse(localStorage.getItem('user'));
            if(this.user.hcid != null || this.user.hcid != ''){
                this.playgame= true;
            }
        }
        this.getGames();
    },
    methods: {
        playGameTracker(game) {
            const track = {
                'event': 'playGame',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'Mainkan Sekarang',
                'eventDetail.label': 'Profile HCID',
                'eventName': game.title || ''
            }
            dataLayer.push(track);
        },
        async getGames() {
            try {
                const response = await axios.get(api_url + '/game');
                const data = response.data.data;
                this.games = data;
            } catch (error) {
                console.log(error);
            }
        },
    }
};
</script>

<style scoped lang="scss">
#games-page{
    background: #000000;
    .card{
        background: #282828;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .img-game{
        max-height: 549px;
    }
    .btn-mainkan{
        background: #6666;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        width: 100%;
    }
    .btn-play{
        background-color: #E61B33;
    }
}
</style>
